<template src="./ServiesDetails.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store.dispatch("lookups/getLookups");

        this.$store
            .dispatch("services/getServiesDetails", this.itemId)
            .then((res) => {
                this.service = res;
            }).catch(() => { });
    },
    computed: {
        units() {
            return [
                ...this.$store.getters["lookups/getLookupByType"](
                    this.$lookupTypes.UnitTypes
                )];
        },
    },

    data() {
        return {
            headers: [
                { text: 'اسم المادة', value: 'description' },
                { text: 'الوحدة ', value: 'unitId' },
                { text: 'الكمية ', value: 'quantity' },
                { text: 'السعر', value: 'price' },
                {
          text: "الاجراءات",
          value: "actions",
          sortable: false,
          align: "start",
        },
            ],

            service: {
                id: null,
                serviceName: null,
                departmentName: null,
                price: null,
                departmentId: null,
                servicesDetails: []

            },
            vm: {
                description: null,
                quantity: null,
                price: null,
                unitId: null,
            },
            indexItem: null,
            editFlag: false,

        };
    },
    methods: {
        confirm() {
            let vm ={
                details:this.service.servicesDetails
                }
            this.$store
                .dispatch("services/serviesDetails", { id: this.itemId, payload: vm })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },
        AddItem() {
           if (this.vm.description == null) {
                showAlert(`يجب ادخال اسم المادة`);
                return false;
            }else if(this.vm.quantity == null) {
                showAlert(`يجب ادخال الكمية   `);
                return false;
            }else if(this.vm.unitId == null) {
                showAlert(`يجب اختيار الوحدة   `);
                return false;
            }else if(this.vm.price == null) {
                showAlert(`يجب ادخال السعر   `);
                return false;
            }
            this.service.servicesDetails.push({
                description: this.vm.description,
                quantity: this.vm.quantity,
                unitId: this.vm.unitId,
                price: this.vm.price,
                // jobGradeName: this.jobGrades[Index].label,
            });
            this.vm.description = null;
            this.vm.quantity = null;
            this.vm.unitId = null;
            this.vm.price = null;
            //this.$refs.info.reset();
        },
        getEditItem(item) {
            this.indexItem = this.service.servicesDetails.findIndex((x) => x.serviceDetailsId == item.serviceDetailsId);
            this.vm.description = this.service.servicesDetails[this.indexItem].description;
            this.vm.quantity = this.service.servicesDetails[this.indexItem].quantity;
            this.vm.unitId = this.service.servicesDetails[this.indexItem].unitId;
            this.vm.price = this.service.servicesDetails[this.indexItem].price;
            this.editFlag = true;
        },
        EditItem() {
            // let Index = this.jobGrades.findIndex((x) => x.value == this.vm.jobGradeId);

            if (this.vm.description == null) {
                showAlert(`يجب ادخال اسم المادة`);
                return false;
            }else if(this.vm.quantity == null) {
                showAlert(`يجب ادخال الكمية   `);
                return false;
            }else if(this.vm.unitId == null) {
                showAlert(`يجب اختيار الوحدة   `);
                return false;
            }else if(this.vm.price == null) {
                showAlert(`يجب ادخال السعر   `);
                return false;
            }
          
            this.service.servicesDetails[this.indexItem].description = this.vm.description;
            this.service.servicesDetails[this.indexItem].quantity = this.vm.quantity;
            this.service.servicesDetails[this.indexItem].unitId = this.vm.unitId;
            this.service.servicesDetails[this.indexItem].price = this.vm.price;

            this.vm.description = null;
            this.vm.quantity = null;
            this.vm.unitId = null;
            this.vm.price = null;

            this.indexItem = null;
            this.editFlag = false;
            //this.$refs.info.reset();
        },

        removeItem(index) {
            this.service.servicesDetails.splice(index, 1);
        },
        back() {

            this.$emit("back");
        },
    },
};
</script>